import { forEach, invert } from 'lodash';
import { defaultSettings } from './constants';

// Create the prefToSetting and settingToPref lookup tables. This is a bit hokey, but it allows us to
// name settings in the snapshot context without the redundant "snapshot" prefix while adding the prefix
// to the userPreferences class.
const prefToSetting = {};
Object.keys(defaultSettings).forEach(key => { prefToSetting['snapshot-' + key] = key; });
const settingToPref = invert(prefToSetting);

/**
 * Creates a wrapepr service around userPrefs that manages a user's snapshot settings.
 */
export function SnapshotSettingsService (userPrefs, validator) {
  const service = this;

  service.events = userPrefs.events.$new();

  // Add snapshot defaults to user prefs.
  userPrefs.registerPreferences(packUserPreferences(defaultSettings));

  // Create pass-through properties to the user prefs obj.
  forEach(settingToPref, (pref, setting) => {
    Object.defineProperty(service, setting, {
      enumerable: true,
      get () {
        return userPrefs.get(pref);
      },
      set (value) {
        // Validate before setting. NOTE: this can throw.
        validator.validate(prefToSetting[pref], value);

        // Update user prefs and publish the change.
        userPrefs.set(pref, value);
        service.events.trigger('settings-service:change');
      }
    });
  });

  // If "onLoad" is defined, call it when user settings are loaded.
  userPrefs.events.on('load', () => {
    service.events.trigger('settings-service:change');
  });
}

// Prefix all snapshot settings with "snapshot" to namespace them in the settings table.
function packUserPreferences (defaultSettings) {
  const o = {};
  forEach(defaultSettings, (value, key) => {
    o[settingToPref[key]] = value;
  });
  return o;
}
